const DescriptionsCard = ({ title, items }) => {

    return (
        <div className="card">
            <div className="card-content">
                <span style={{ fontWeight: "bold"}} className="card-title">{title}</span>
                {items.map((item,index) => (
                    <p key={index}>
                        <b>{title === 'Segments' ? item.Provider + ' | ' + item.SegmentType : item.Index}:</b> {item.Description}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default DescriptionsCard;